import React from "react";

import { Stack } from "react-bootstrap";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";

import { ParticipantWithSinglePseudonym } from "@components/account_profile/ParticipantDropdown";
import ParticipantSearch from "@components/account_profile/ParticipantSearch";

import styles from "./SearchUser.module.scss";

export const SearchBar: React.FC = () => {
  const navigate = useNavigate();

  const handleParticipantSelect = (participant: ParticipantWithSinglePseudonym | null) => {
    if (!participant) {
      return;
    }
    const participantId = participant?.participant_id;
    const profilePath = ROUTES.Dashboard.Profile.buildPath({ participantId });
    navigate(profilePath);
  };

  return (
    <>
      <div className={classNames(styles["search-container"], "position-relative w-100")}>
        <Stack className="col-6 m-auto pt-5 pb-5">
          <h4 className={classNames(styles["search-accounts-title"], "mb-4")}>Search accounts</h4>
          <div className="position-relative">
            <ParticipantSearch
              onParticipantSelect={handleParticipantSelect}
              variables={{
                filter_by: [{ field: "filterByParticipantId", eq: "true" }],
              }}
            />
          </div>
        </Stack>
      </div>
      <span className={classNames(styles["search-user-title"], "mt-3")}>Account that need actioning</span>
    </>
  );
};
